import { GonvarriProduct } from "../models/gonvarri-product.model";

export class AttemptToCreateQuoteWithContractProductsEvent {
    products?: GonvarriProduct[];
}
